export const setUserToken = 'auth/setUserToken'
export const setIsLogged = 'auth/setIsLogged'
export const setSubdomain = 'auth/setSubdomain'
export const setCustomerToken = 'auth/setCustomerToken'
export const setUser = 'auth/setUser'
export const setAdmUser = 'auth_admin/setAdmUser'
export const setCust = 'auth/setCust'
export const setCurrentRoute = 'setCurrentRoute'
export const prevRoute = 'prevRoute'
export const setWizardDone = 'setWizardDone'
export const setSeller = 'setSeller'



// WEBPACK FOOTER //
// ./src/app/pages/auth/vuex/mutations-types.js